export default {
  breakpoints: [40, 58, 64, 72].map((n) => `${n}em`),
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  fonts: {
    grot10: 'Founders Grotesk, sans-serif',
    sans: 'GT-America-Extended-Bold, sans-serif',
  },
  spacing: [1],
};
